export default __webpack_public_path__ + "static/media/bgstyle03.a4746f34.jpg";